import { render, staticRenderFns } from "./phoneNav.vue?vue&type=template&id=75c25bf7&scoped=true&"
import script from "./phoneNav.vue?vue&type=script&lang=js&"
export * from "./phoneNav.vue?vue&type=script&lang=js&"
import style0 from "./phoneNav.vue?vue&type=style&index=0&id=75c25bf7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c25bf7",
  null
  
)

export default component.exports